import React, { useEffect, useState } from "react";
import strings from "../../global/constants/StringConstants";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import SignIn from "./components/SignIn/SignIn";
import SignUp from "./components/SignUp/SignUp";
import OnBoadingSelectIndustry from "./components/OnBoadingSelectIndustry/OnBoadingSelectIndustry";
import PasswordResetLink from "./components/PasswordResetLink/PasswordResetLink";
import { useSelector } from "react-redux";
import {
  selectAuthenticated,
  selectRole1,
} from "../../redux/authSlice";
import history from "../../utils/history";
import urls from "../../global/constants/UrlConstants";
import MobileVerification from "./components/MobileVerification/MobileVerification";
import { loginForm } from "./components/SignIn/SignTypesAndValidation";
import { consumeLoginRedirect } from "../../global/components/PrivateRoute/PrivateRoute";

interface CustomProps {
  location?: Location;
}

const LandingPage = (props: CustomProps) => {
  const [formFields, setFormFields] = useState(loginForm);
  const isAuthenticated: boolean = useSelector(selectAuthenticated);
  const hierarchyLevel = useSelector(selectRole1);

  const redirectPage = (level: any) => {
    if (level === 1) {
      return urls.dashboardViewPath;
    }
    return urls.dashboardViewPathMy;
  };

  // Never call history.push during render — it can thrash navigation and freeze the tab.
  useEffect(() => {
    if (!isAuthenticated) return;
    const stored = consumeLoginRedirect();
    const stateFrom = (history.location.state as any)?.from;
    const fromPath = stateFrom?.pathname
      ? `${stateFrom.pathname}${stateFrom.search || ""}`
      : stored;
    const isSafeReturn =
      fromPath.startsWith("/") &&
      !fromPath.startsWith("//") &&
      !/login|sign-up|signup/i.test(fromPath);
    const target = isSafeReturn ? fromPath : redirectPage(hierarchyLevel);
    const targetPath = target.split("?")[0];
    if (history.location.pathname !== targetPath) {
      history.push(target);
    }
  }, [isAuthenticated, hierarchyLevel]);

  useEffect(() => {
    if (isAuthenticated) return;
    const location = props.location?.pathname?.split("/")[1]?.toLowerCase();
    const known = [
      strings.LOGIN,
      strings.FORGOTPASSWORD,
      strings.CHANGE_PASSWORD,
      strings.SIGN_UP,
      strings.ONBOADING_SECLECT_INDUSTRY,
      strings.RESTPASSWORDLINK,
      strings.OPTSCREEN,
    ];
    if (location && !known.includes(location)) {
      history.replace(urls.loginViewPath);
    }
  }, [isAuthenticated, props.location?.pathname]);

  const getComponentBasedOnURL = () => {
    const location = props.location?.pathname?.split("/")[1]?.toLowerCase();
    switch (location) {
      case strings.LOGIN:
        return <SignIn formFields={formFields} setFormFields={setFormFields} />;
      case strings.FORGOTPASSWORD:
        return <ForgotPassword />;
      case strings.CHANGE_PASSWORD:
        return <ResetPassword />;
      case strings.SIGN_UP:
        return <SignUp />;
      case strings.ONBOADING_SECLECT_INDUSTRY:
        return <OnBoadingSelectIndustry />;
      case strings.RESTPASSWORDLINK:
        return <PasswordResetLink />;
      case strings.OPTSCREEN:
        return <MobileVerification formFields={formFields} />;
      default:
        return <SignIn formFields={formFields} setFormFields={setFormFields} />;
    }
  };

  if (isAuthenticated) {
    return null;
  }

  return <div className="w-full">{getComponentBasedOnURL()}</div>;
};

export default LandingPage;
